import { render } from "./CustomTermWithAI.vue?vue&type=template&id=5c252860&scoped=true"
import script from "./CustomTermWithAI.vue?vue&type=script&lang=js"
export * from "./CustomTermWithAI.vue?vue&type=script&lang=js"

import "./CustomTermWithAI.vue?vue&type=style&index=0&id=5c252860&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c252860"]])

export default __exports__